document.addEventListener('DOMContentLoaded', () => {
  const prose = document.querySelector('.collection-header .prose');
  if (!prose) return;

  const nodes = Array.from(prose.children);
  if (nodes.length <= 1) return;

  // Alles ab dem 2. Element einklappen
  const more = document.createElement('div');
  more.className = 'collection-more';

  nodes.slice(1).forEach(n => more.appendChild(n));
  prose.appendChild(more);

  // Toggle-Button
  const toggle = document.createElement('button');
  toggle.className = 'collection-toggle';
  toggle.type = 'button';
  toggle.textContent = 'Mehr lesen';

  toggle.addEventListener('click', () => {
    const open = more.classList.toggle('is-open');
    toggle.textContent = open ? 'Weniger lesen' : 'Mehr lesen';
  });

  prose.appendChild(toggle);
});
